import { createFileRoute, Link } from "@tanstack/react-router";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";

export const Route = createFileRoute("/terms")({
  head: () => ({
    meta: [
      { title: "Terms of Use — Mr. B Quotes" },
      { name: "description", content: "Terms of use for Mr. B Quotes (mrbquotes.com): site, games, and embedded content." },
      { property: "og:title", content: "Terms of Use — Mr. B Quotes" },
      { property: "og:url", content: "/terms" },
    ],
    links: [{ rel: "canonical", href: "/terms" }],
  }),
  component: Terms,
});

function Terms() {
  return (
    <div className="min-h-screen">
      <SiteHeader />
      <main id="main">
      <article className="mx-auto max-w-3xl px-4 py-16 sm:py-20 prose prose-invert max-w-none">
        <div className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground">Legal</div>
        <h1 className="mt-2 font-display text-4xl sm:text-5xl text-foreground">Terms of Use</h1>
        <p className="text-xs text-muted-foreground">Last updated: June 25, 2026</p>

        <p className="text-muted-foreground mt-6">
          By using <strong className="text-foreground">mrbquotes.com</strong>, you agree to these terms. They're short.
        </p>

        <h2 className="font-display text-2xl text-gold mt-10">Use of the site</h2>
        <p className="text-muted-foreground">
          You may use Mr. B Quotes for personal, non-commercial enjoyment — playing the games, sharing quotes,
          and watching embedded videos. Don't try to break the site, scrape it at scale, or use it to harm others.
        </p>

        <h2 className="font-display text-2xl text-gold mt-8">Quotes & attribution</h2>
        <p className="text-muted-foreground">
          We make a good-faith effort to attribute every quote to its original author and source. Famous quotations are
          frequently misattributed in the wider world; if you spot an error in our library, let us know via YouTube.
        </p>

        <h2 className="font-display text-2xl text-gold mt-8">Intellectual property</h2>
        <p className="text-muted-foreground">
          The Mr. B Quotes name, logo, original copy, game design, and visual identity are © Mr. B Quotes.
          Quoted text remains the work of its respective authors and is used here for educational and editorial purposes.
        </p>

        <h2 className="font-display text-2xl text-gold mt-8">No warranty</h2>
        <p className="text-muted-foreground">
          The site is provided "as is." We don't promise it will be available at all times or free from bugs.
          Use it at your own enjoyment.
        </p>

        <h2 className="font-display text-2xl text-gold mt-8">Changes</h2>
        <p className="text-muted-foreground">
          We may update these terms. Material changes will be reflected on this page with a new "Last updated" date.
        </p>

        <p className="text-xs text-muted-foreground mt-12">
          See also: <Link to="/privacy" className="text-gold hover:underline">Privacy Policy</Link>.
        </p>
      </article>
      </main>
      <SiteFooter />
    </div>
  );
}
